import { render, staticRenderFns } from "./NetworkSecurityInternet.vue?vue&type=template&id=2480eca9&scoped=true&"
import script from "./NetworkSecurityInternet.vue?vue&type=script&lang=ts&"
export * from "./NetworkSecurityInternet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480eca9",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepperContent,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2480eca9')) {
      api.createRecord('2480eca9', component.options)
    } else {
      api.reload('2480eca9', component.options)
    }
    module.hot.accept("./NetworkSecurityInternet.vue?vue&type=template&id=2480eca9&scoped=true&", function () {
      api.rerender('2480eca9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/requirement/network-security-internet/views/NetworkSecurityInternet.vue"
export default component.exports